import { resolveFeedActor, type ActorDisplay } from "@/components/app/feed/feed-actor";
import type {
  CurrentMlxUser,
  WorkspaceOrganizationMember,
} from "@/lib/mlx-workspace-client";

export type FeedActor = {
  label: string;
  imageUrl: string | null;
  initials: string;
  identity?: ActorDisplay["identity"];
};

export function feedActor(
  authorId: string | null,
  authorType: "user" | "agent" | "service" | "unknown",
  currentUser: CurrentMlxUser | null,
  membersByUserId: Map<string, WorkspaceOrganizationMember>,
): FeedActor {
  const actor = resolveFeedActor(
    {
      id: authorId ?? "",
      subjectId: null,
      type: authorType,
      clientApp: null,
      interfaceType: null,
      executedByTwin: false,
    },
    membersByUserId,
    new Set(currentUser ? [currentUser.id] : []),
    currentUser,
  );
  return {
    label: actor.name,
    imageUrl: actor.imageUrl,
    initials: actor.initials,
    identity: actor.identity,
  };
}
